// Relationship options dropdown
export const RELATIONSHIP_OPTIONS = [
  { value: '', label: 'Select relationship...' },
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'son', label: 'Son' },
  { value: 'daughter', label: 'Daughter' },
  { value: 'grandfather', label: 'Grandfather' },
  { value: 'grandmother', label: 'Grandmother' },
  { value: 'grandson', label: 'Grandson' },
  { value: 'granddaughter', label: 'Granddaughter' },
  { value: 'brother', label: 'Brother' },
  { value: 'sister', label: 'Sister' },
  { value: 'uncle', label: 'Uncle' },
  { value: 'aunt', label: 'Aunt' },
  { value: 'nephew', label: 'Nephew' },
  { value: 'niece', label: 'Niece' },
  { value: 'cousin', label: 'Cousin' },
  { value: 'husband', label: 'Husband' },
  { value: 'wife', label: 'Wife' },
  { value: 'spouse', label: 'Spouse' },
  { value: 'in-law', label: 'In-Law' },
  { value: 'step-parent', label: 'Step-Parent' },
  { value: 'step-child', label: 'Step-Child' },
  { value: 'step-sibling', label: 'Step-Sibling' },
  { value: 'godparent', label: 'Godparent' },
  { value: 'godchild', label: 'Godchild' },
  { value: 'other', label: 'Other' }
];
